"use strict";
/**
 * Error Codes that are used to identify HBT Validation Errors.
 * Each code object consists of a code and description.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbtValidationErrorCodes = exports.validationErrorMessage = void 0;
exports.validationErrorMessage = function (validationError, property) {
    return property != null
        ? "[" + validationError.code + "]: " + property + " " + validationError.description
        : "[" + validationError.code + "]: " + validationError.description;
};
exports.HbtValidationErrorCodes = {
    /*
     * HBT General Validations (10000 - 19999)
     */
    HBT_VAL_ERR_INVALID_CMHC_ACCOUNT_NUMBER: {
        code: 'HBT_VAL_ERR_10000',
        description: 'CMHC Account Number must be an 8 digit integer',
    },
    HBT_VAL_ERR_MUST_CONTAIN_ALHPABETS_AND_DASHES_ONLY: {
        code: 'HBT_VAL_ERR_10001',
        description: 'Must contain alphabets and dashes only',
    },
    HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY: {
        code: 'HBT_VAL_ERR_10002',
        description: 'Must contain digits only',
    },
    HBT_VAL_ERR_MUST_BE_A_VALID_EMAIL_FORMAT: {
        code: 'HBT_VAL_ERR_10003',
        description: 'Must be a valid email format',
    },
    /*
     * HBT Claim Validations (20000 - 29999)
     */
    HBT_VAL_ERR_DATE_BEFORE_1996: {
        code: 'HBT_VAL_ERR_20000',
        description: 'cannot be before 1996-01-01.',
    },
    HBT_VAL_ERR_STRICTLY_PAST_DATE: {
        code: 'HBT_VAL_ERR_20001',
        description: 'needs to be a strictly past date',
    },
    HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_REQUIRED: {
        code: 'HBT_VAL_ERR_20002',
        description: 'is required if Type of Claim is Deficiency Sale',
    },
    HBT_VAL_ERR_DEFICIENCY_SALE_VALUE_FORBIDDEN: {
        code: 'HBT_VAL_ERR_20003',
        description: 'is forbidden if Type of Claim is not Deficiency Sale',
    },
    HBT_VAL_ERR_INVALID_ACCOUNT_NUMBER: {
        code: 'HBT_VAL_ERR_20005',
        description: 'Must be 8 digits',
    },
    HBT_ERR_APPROVE_BEHALF_OF_OTHER_PERSON_DOCUMENTID_REQUIRED: {
        code: 'HBT_ERR_20006',
        description: 'Please provide at least 1 documentID to prove that you are eligible to approve the claim on behalf of another user',
    },
    HBT_ERR_BELOW_MINIMUM_APPROVAL_ROLE: {
        code: 'HBT_ERR_20007',
        description: 'The user does not have the correct financial authority to approve this finalClaim',
    },
    HBT_ERR_APPROVAL_FROM_PROBATIONARY_OFFICER: {
        code: 'HBT_ERR_20008',
        description: 'The user is a probationary officer and does not have the authority to approve finalClaim',
    },
    HBT_VAL_ERR_SUSPENSE_CONDITION_OVERRIDE_BLANK_COMMENT: {
        code: 'HBT_ERR_2008',
        description: 'Comment cannot be blank when overriding a suspense condition',
    },
    HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE: {
        code: 'HBT_VAL_ERR_20006',
        description: 'Date must be prior to the claim submission',
    },
    /* Claim.Indicator Validation Errors */
    HBT_VAL_ERR_INDICATOR_DATE_0: {
        code: 'HBT_VAL_ERR_20007',
        description: 'Underwriting End Date must be greater than or equal to Underwriting Information Received Date',
    },
    /* Claim.Indicator Validation Errors */
    HBT_VAL_ERR_INDICATOR_DATE_1: {
        code: 'HBT_VAL_ERR_20008',
        description: 'Underwriting End Date must be greater than or equal to Underwriting Information Requested Date',
    },
    HBT_ERR_APPROVAL_MANUAL_ADJUSTMENT_NO_AMOUNT: {
        code: 'HBT_ERR_20009',
        description: 'The manual adjustment does not have an amount for this approval.',
    },
    HBT_VAL_ERR_CANNOT_BE_FUTURE_DATE: {
        code: 'HBT_VAL_ERR_20010',
        description: 'cannot be a future date',
    },
    /* Claim.Listing Validation Errors */
    HBT_VAL_ERR_LISTING_0: {
        code: 'HBT_VAL_ERR_20100',
        description: 'Revised List Price cannot be the same as the Lender List Price.',
    },
    HBT_VAL_ERR_LISTING_1: {
        code: 'HBT_VAL_ERR_20101',
        description: 'in Second Listing cannot be greater than or the same as the amount in First Listing.',
    },
    HBT_VAL_ERR_LISTING_2: {
        code: 'HBT_VAL_ERR_20102',
        description: 'in Second Listing cannot be earlier than date in First Listing.',
    },
    HBT_VAL_ERR_LISTING_3: {
        code: 'HBT_VAL_ERR_20103',
        description: "Listing expiry date must be greater than approved lender's second listing date",
    },
    // TODO: update to use HBT_VAL_ERR_20104 instead
    HBT_VAL_ERR_LISTING_4: {
        code: 'HBT_VAL_ERR_20004',
        description: 'Listing Expiry Date cannot be a future date, earlier than 1996-01-01, or earlier than the Listing Date',
    },
    HBT_VAL_ERR_LISTING_5: {
        code: 'HBT_VAL_ERR_20108',
        description: 'First Listing Expiry Date must be at least 90 days after First Listing Date',
    },
    /* Claim.PartialPayments Validation Errors */
    HBT_VAL_ERR_PARTIAL_PAYMENTS_0: {
        code: 'HBT_VAL_ERR_20200',
        description: 'Date Paid for Partial Payments cannot be earlier than Due Date of Last Installment Paid. Please enter a valid date.',
    },
    /* Claim.NOIRentalIncome Validation Errors */
    HBT_VAL_ERR_NOI_RENTAL_INCOME: {
        code: 'HBT_VAL_ERR_20201',
        description: 'Date Paid for N.O.I / Rental Income cannot be earlier than Due Date of Last Installment Paid. Please enter a valid date.',
    },
    HBT_VAL_ERR_DATE_LEGAL_ACTION_COMPLETED: {
        code: 'HBT_VAL_ERR_20202',
        description: 'Date Legal Action Completed cannot be earlier than date in Date Legal Action Started.',
    },
    HBT_VAL_ERR_PROPERTY_BED_UNIT_COUNT: {
        code: 'HBT_VAL_ERR_20203',
        description: 'Please provide a bed or unit count',
    },
    HBT_VAL_ERR_PROPERTY_POSTAL_CODE_PROVINCE_MISMATCH: {
        code: 'HBT_VAL_ERR_20204',
        description: 'Postal Code entered does not correspond with the indicated Province / Territory. Please enter a valid postal code.',
    },
    HBT_VAL_ERR_ADJUSTMENT_CODE_MAX_OCCURRENCE: {
        code: 'HBT_VAL_ERR_20205',
        description: 'Maximum allowed number of occurrences has been reached for adjustment code.',
    },
    HBT_VAL_ERR_COMPLETE_CLAIM_RECEIVED_DATE: {
        code: 'HBT_VAL_ERR_20206',
        description: 'Complete Claim Received Date must be greater than or equal to Claim Received Date.',
    },
    HBT_VAL_ERR_DATE_RECEIVED_LENDER_NOTIFICATION: {
        code: 'HBT_VAL_ERR_20207',
        description: 'Received lender notification date cannot be earlier than due date of last paid installment.',
    },
    HBT_VAL_ERR_DATE_INTEREST_ADJUSTMENT_DATE: {
        code: 'HBT_VAL_ERR_20208',
        description: 'Interest adjustment date cannot be greater than due date of last paid installment.',
    },
    HBT_VAL_ERR_DATE_RECEIVED_LENDER_NOTIFICATION_LEGAL_ACTION_STARTED_DATE: {
        code: 'HBT_VAL_ERR_20209',
        description: 'Received lender notification date has to be greater than legal action started date',
    },
    HBT_VAL_ERR_LEGAL_ACTION_END_DATE_LENDER_NOTIFICATION_DATE: {
        code: 'HBT_VAL_ERR_20210',
        description: 'Legal action end date must be before the received lender notification date.',
    },
    HBT_VAL_ERR_FINALCLAIM_PAYEE_ERP: {
        code: 'HBT_VAL_ERR_20211',
        description: 'The FinalClaim Payee is failing some validations required for ERP',
    },
    HBT_VAL_ERR_DATE_BORROWER_CHARGE_RECEIVED_DATE: {
        code: 'HBT_VAL_ERR_20212',
        description: 'Interest adjustment date cannot be greater than due date of last paid installment.',
    },
    /*
     * HBT User Validations (30000 - 39999)
     */
    HBT_ERR_AUTHORITY_DELEGATION_TO_PROBATIONARY_OFFICER: {
        code: 'HBT_ERR_30000',
        description: 'The user is a probationary officer and cannot be delegated further authority.',
    },
    HBT_ERR_CREATE_DELEGATION_DELEGATOR_MISSING_MASTER_ACCESS: {
        code: 'HBT_ERR_9001',
        description: 'The delegator is missing master access to the selected modules',
    },
    HBT_ERR_CREATE_DELEGATION_TO_USER_MISSING_ACCESS: {
        code: 'HBT_ERR_9002',
        description: 'The To-User is missing access to the selected modules',
    },
    HBT_ERR_CREATE_DELEGATION_FROM_USER_MISSING_ACCESS: {
        code: 'HBT_ERR_9003',
        description: 'The From-User is missing access to the selected modules',
    },
    HBT_VAL_ERR_DELEGATION_END_DATE_PROIR_TO_DELEGATION_START_DATE: {
        code: 'HBT_VAL_ERR_9004',
        description: 'Delegation End Date must be greater than or equal to Delegation Start Date',
    },
    HBT_VAL_ERR_START_DATE_BEFORE_CURRENT: {
        code: 'HBT_VAL_ERR_9005',
        description: 'Start date cannot be prior to the current date',
    },
    /*
     * HBT Arrears Validations (40000 - 49999)
     */
    HBT_VAL_ERR_ATTACHMENT_REQUIRED_PRIMARY_APPROVAL: {
        code: 'HBT_VAL_ERR_40000',
        description: "The Approval's first approved review requires to have at least 1 attachment submitted",
    },
    HBT_VAL_ERR_SECONDARY_APPROVAL_SAME_USER: {
        code: 'HBT_VAL_ERR_40001',
        description: "The Approval cannot have both it's approved reviews come from the same user",
    },
    HBT_VAL_ERR_NO_ACCESS_TO_FI: {
        code: 'HBT_VAL_ERR_40002',
        description: 'This Arrears Submission cannot happen because the authenticated user does not have access to this Financial Institution under the Arrears Module',
    },
    HBT_VAL_ERR_NO_ACCESS_TO_TRANSIT_UNDER_FI: {
        code: 'HBT_VAL_ERR_40003',
        description: 'This Arrears Submission cannot happen because the authenticated user does not have access to this Transit under the Financial Institution',
    },
    HBT_VAL_ERR_INVALID_FI_CODE: {
        code: 'HBT_VAL_ERR_40004',
        description: 'This Arrears Submission cannot happen because the FI code is invalid and does not exist in general',
    },
    HBT_VAL_ERR_INVALID_TRANSIT_FOR_CORRESPONDING_FI_CODE: {
        code: 'HBT_VAL_ERR_40005',
        description: 'This Arrears Submission cannot happen because the Transit number does not exist under the Financial Institution in general',
    },
    HBT_VAL_ERR_BELOW_MINIMUM_ARREARS_PRIMARY_APPROVAL_FINANCIAL_AUTHORITY: {
        code: 'HBT_VAL_ERR_40006',
        description: 'The user does not meet the minimum primary Arrears financial authority to approve this Arrears',
    },
    HBT_VAL_ERR_BELOW_MINIMUM_ARREARS_SECONDARY_APPROVAL_FINANCIAL_AUTHORITY: {
        code: 'HBT_VAL_ERR_40007',
        description: 'The user does not meet the minimum secondary Arrears financial authority to approve this Arrears',
    },
};
exports.default = exports.HbtValidationErrorCodes;
